import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner, EuiPanel, EuiSpacer, EuiText} from '@elastic/eui';
import { Action } from '../../../components/Menus/interface';
import { Menu } from '../../../components/Menus';
import FiltrosMenu from '../../../components/Menus/filtros';
import { useUserSettings } from '../../../context/CurrentUserContext';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
import { MaskLoad } from '../../../components/Layout';

interface Props {
  data: any;
  columnsUser: any;
  handleFilter(filtro: any): any;
  handleDownloadAllAdjuntos(filtro:any): any;
  handleDownloadAdjuntosPartes(ids:string,filename:string): any;
  isLoading:boolean;
}

let _msgLoading = `Cargando datos....`;
    
const DetallePartesScreen = (props: Props) => {
  const ref:any = useRef();
  const {currentUser}:any = useUserSettings();

  let { data, columnsUser, handleFilter, handleDownloadAllAdjuntos, handleDownloadAdjuntosPartes, isLoading} = props;
  
  let [selected, setSelected] = useState<any>([]);
  let [filtro, setFiltro] = useState<any>(undefined)

  useEffect(()=> {
    if(filtro){
      filtrarPartes();
    }
  },[filtro])
  
  const onExport = () =>{
    ref && ref.current.onExport();
  }

  const onDownloadAllAdjuntos = ()=>{
    _msgLoading = `Preparando archivo de descarga....`
    handleDownloadAllAdjuntos(filtro);
  }

  const onDownloadAdjuntos = ()=>{
    const ids:string = selected.map((s:any)=> s.idParte).join(',');
    
    const filename:any = prompt('Nombre del archivo a descargar');
    handleDownloadAdjuntosPartes(ids,filename);
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onSelected = (selection: any) => {
    setSelected([...selection])
  }

  const filtroInicial = (filtro:any)=>{
    setFiltro(filtro);
    handleFilter && handleFilter(filtro)
  }

  const filtrarPartes = () => {
    _msgLoading = `Cargando detalle....`
    handleFilter(filtro)
  }

  const btnDownloadAdjuntosRender:boolean = useMemo(() =>{
    if((currentUser!==undefined && currentUser!==null) && currentUser.perfil === PERFIL_ADMIN)
    {return true}else{ return false}
  },[currentUser])

  //(selected&&selected.length === 0)

  const Actions = useMemo(():Action[] => [
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false},
    {actionGroup:{actions:[
      {text:"Adjuntos",size:"s", isDisabled: false, visible:btnDownloadAdjuntosRender},
      {handle:onDownloadAllAdjuntos,text:"Descargar Todos",size:"s", isDisabled:false},
      {handle:onDownloadAdjuntos,text:"Descargar Seleccionados",size:"s", isDisabled:(selected&&selected.length === 0)}
    ]}}
  ],[btnDownloadAdjuntosRender,onExport,onFilterClear,onDownloadAllAdjuntos,selected])

  const getView = () => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selected={selected}
          onSelected={onSelected}
          columnsUser={columnsUser}
          selector={false}
          ref={ref}
        />
      </>
    )
  }

  return (
    <>
    <FlexView column basis="100%">
        <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
          <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter">
            <FiltrosMenu selectorEstado filtroInicial = {filtroInicial} dateInit onChangeFilter={setFiltro}/>
          </EuiFlexGroup>
          <Menu actions={Actions} className="actions"/>
         </EuiFlexGroup>
        <EuiSpacer size="m" />
      <FlexView grow={1} shrink={1} basis="auto">
        <FlexView column shrink={0} basis="100%">
          {getView()}
        </FlexView>
      </FlexView>
    </FlexView>
    {<MaskLoad isLoading={isLoading} text={_msgLoading}/>}
    </>
  );
};

export default DetallePartesScreen;
